<template>
  <div>
    <category-layout>
      <section class="about-item-area">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="about-author-content pt-15">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                      <a href="index.html">Home</a>
                    </li>
                    <li class="breadcrumb-item"><a href="#">Category</a></li>
                    <li class="breadcrumb-item active" aria-current="page">
                      Sports
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            <div class="col-lg-8">
              <div class="about-tab-btn mt-40">
                <div class="archive-btn">
                  <ul>
                    <li>
                      <span>Category: <span>Sports</span></span>
                    </li>
                  </ul>
                </div>
                <div class="about-post-items">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="feature-news-item">
                        <div class="feature-news-thumb">
                          <img
                            src="@/assets/images/feature/feature-news-1.jpg"
                            alt="feature"
                          />
                          <div class="meta-categores">
                            <span>TECHNOLOGY</span>
                          </div>
                        </div>
                        <div class="feature-news-content">
                          <p>
                            The worried doctors stood together after their
                            rounds, weighing the risks.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="feature-news-item">
                        <div class="feature-news-thumb">
                          <img
                            src="@/assets/images/feature/feature-news-2.jpg"
                            alt="feature"
                          />
                          <div class="meta-categores">
                            <span>TECHNOLOGY</span>
                          </div>
                        </div>
                        <div class="feature-news-content">
                          <p>
                            The worried doctors stood together after their
                            rounds, weighing the risks.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="feature-news-item">
                        <div class="feature-news-thumb">
                          <img
                            src="@/assets/images/feature/feature-news-3.jpg"
                            alt="feature"
                          />
                          <div class="meta-categores">
                            <span>TECHNOLOGY</span>
                          </div>
                        </div>
                        <div class="feature-news-content">
                          <p>
                            The worried doctors stood together after their
                            rounds, weighing the risks.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="feature-news-item">
                        <div class="feature-news-thumb">
                          <img
                            src="@/assets/images/feature/feature-news-1.jpg"
                            alt="feature"
                          />
                          <div class="meta-categores">
                            <span>TECHNOLOGY</span>
                          </div>
                        </div>
                        <div class="feature-news-content">
                          <p>
                            The worried doctors stood together after their
                            rounds, weighing the risks.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="feature-news-item">
                        <div class="feature-news-thumb">
                          <img
                            src="@/assets/images/feature/feature-news-2.jpg"
                            alt="feature"
                          />
                          <div class="meta-categores">
                            <span>TECHNOLOGY</span>
                          </div>
                        </div>
                        <div class="feature-news-content">
                          <p>
                            The worried doctors stood together after their
                            rounds, weighing the risks.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="feature-news-item">
                        <div class="feature-news-thumb">
                          <img
                            src="@/assets/images/feature/feature-news-3.jpg"
                            alt="feature"
                          />
                          <div class="meta-categores">
                            <span>TECHNOLOGY</span>
                          </div>
                        </div>
                        <div class="feature-news-content">
                          <p>
                            The worried doctors stood together after their
                            rounds, weighing the risks.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="feature-news-item">
                        <div class="feature-news-thumb">
                          <img
                            src="@/assets/images/feature/feature-news-1.jpg"
                            alt="feature"
                          />
                          <div class="meta-categores">
                            <span>TECHNOLOGY</span>
                          </div>
                        </div>
                        <div class="feature-news-content">
                          <p>
                            The worried doctors stood together after their
                            rounds, weighing the risks.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="feature-news-item">
                        <div class="feature-news-thumb">
                          <img
                            src="@/assets/images/feature/feature-news-2.jpg"
                            alt="feature"
                          />
                          <div class="meta-categores">
                            <span>TECHNOLOGY</span>
                          </div>
                        </div>
                        <div class="feature-news-content">
                          <p>
                            The worried doctors stood together after their
                            rounds, weighing the risks.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="feature-news-item">
                        <div class="feature-news-thumb">
                          <img
                            src="@/assets/images/feature/feature-news-3.jpg"
                            alt="feature"
                          />
                          <div class="meta-categores">
                            <span>TECHNOLOGY</span>
                          </div>
                        </div>
                        <div class="feature-news-content">
                          <p>
                            The worried doctors stood together after their
                            rounds, weighing the risks.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="feature-news-item">
                        <div class="feature-news-thumb">
                          <img
                            src="@/assets/images/feature/feature-news-1.jpg"
                            alt="feature"
                          />
                          <div class="meta-categores">
                            <span>TECHNOLOGY</span>
                          </div>
                        </div>
                        <div class="feature-news-content">
                          <p>
                            The worried doctors stood together after their
                            rounds, weighing the risks.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="feature-news-item">
                        <div class="feature-news-thumb">
                          <img
                            src="@/assets/images/feature/feature-news-2.jpg"
                            alt="feature"
                          />
                          <div class="meta-categores">
                            <span>TECHNOLOGY</span>
                          </div>
                        </div>
                        <div class="feature-news-content">
                          <p>
                            The worried doctors stood together after their
                            rounds, weighing the risks.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="feature-news-item">
                        <div class="feature-news-thumb">
                          <img
                            src="@/assets/images/feature/feature-news-3.jpg"
                            alt="feature"
                          />
                          <div class="meta-categores">
                            <span>TECHNOLOGY</span>
                          </div>
                        </div>
                        <div class="feature-news-content">
                          <p>
                            The worried doctors stood together after their
                            rounds, weighing the risks.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="feature-news-item">
                        <div class="feature-news-thumb">
                          <img
                            src="@/assets/images/feature/feature-news-1.jpg"
                            alt="feature"
                          />
                          <div class="meta-categores">
                            <span>TECHNOLOGY</span>
                          </div>
                        </div>
                        <div class="feature-news-content">
                          <p>
                            The worried doctors stood together after their
                            rounds, weighing the risks.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="feature-news-item">
                        <div class="feature-news-thumb">
                          <img
                            src="@/assets/images/feature/feature-news-2.jpg"
                            alt="feature"
                          />
                          <div class="meta-categores">
                            <span>TECHNOLOGY</span>
                          </div>
                        </div>
                        <div class="feature-news-content">
                          <p>
                            The worried doctors stood together after their
                            rounds, weighing the risks.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="bussiness-btn mt-30">
                        <a class="main-btn main-btn-2" href="#">See more</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <style-one :datas="posts.slice(1, 6)" />
            </div>
          </div>
        </div>
      </section>
    </category-layout>
  </div>
</template>

<script>
import StyleOne from "../Utility/Sidebar/StyleOne.vue";
import CategoryLayout from "./CategoryLayout.vue";
import Posts from "../Data/TrendingHomeThree";
export default {
  components: { CategoryLayout, StyleOne },
  data: () => ({
    posts: Posts.data,
  }),
};
</script>

<style></style>
